var styles = ["p.observation[_ngcontent-%COMP%]{font-size:.7rem;white-space:pre-wrap;max-height:4rem;max-width:50vw;word-break:break-word}"];
export { styles as styles };
